import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { Place } from 'react-tooltip';

import Tooltip from '../Tooltip';
import { StyledText } from './styles';

import type { ReactNode } from 'react';

interface Props {
  id: string;
  position?: Place;
  showIcon?: boolean;
  text?: ReactNode;
  tooltipHelperText?: ReactNode;
  tooltipText: ReactNode;
}

const Infotip = ({ id, showIcon = true, position = 'top', text, tooltipHelperText, tooltipText }: Props) => {
  return (
    <>
      <StyledText
        data-for={id}
        data-tip
      >
        {showIcon && <FontAwesomeIcon icon={faInfoCircle} />}
        {text && <span>{text}</span>}
      </StyledText>
      <Tooltip
        helperText={tooltipHelperText}
        id={id}
        position={position}
        value={tooltipText}
      />
    </>
  );
};

export default Infotip;
